const actions = {
  FETCH_ENTITY: 'entity/FETCH_ENTITY',
  FETCH_RESOURCE: 'entity/FETCH_RESOURCE',
  FETCH_USER_CONTACT_ADDRESS: 'entity/FETCH_USER_CONTACT_ADDRESS',
}

export default actions
